import React from 'react'

import { Button, FilteredSearchBar } from 'src/chrome'
import { SearchFilter } from 'src/chrome/FilteredSearchBar/types'
import { Memoized } from 'src/hooks/dependencies'

import styles from '../../containers/contactManager.module.scss'

type Props = {
  onOpenGroups: () => void
  onAdd: () => void
  filters: SearchFilter[]
  setFilters: Memoized<(filters: SearchFilter[]) => void>
  setTerms: Memoized<(terms: string) => void>
  onImport: () => void
}

const ContactHeader: React.FC<Props> = props => {
  const { filters, onOpenGroups, onImport, setFilters, onAdd, setTerms } = props

  return (
    <div className={styles.headerContainer}>
      <div className={styles.actionButtons}>
        <Button
          id={'import_csv_btn'}
          title={'Import Contacts'}
          icon={'CONTACT'}
          iconColor={'#6f8394'}
          iconSize={15}
          disabled={false}
          onClick={onImport}
          className={styles.importButton}
        />
        <Button
          title={'View Groups'}
          className={styles.contextButton}
          icon={'FUNNEL'}
          iconColor={'#FFF'}
          iconSize={15}
          buttonColor={'pink'}
          onClick={onOpenGroups}
          id="view_groups_btn"
        />
      </div>
      <div className={styles.searchBar}>
        <FilteredSearchBar
          filters={filters}
          className={styles.searchFilter}
          setTerms={setTerms}
          setFilters={setFilters}
          autocomplete={'off'}
        />
      </div>
      <div className={styles.addButton}>
        <Button
          title={'Add Contact'}
          icon={'ADD'}
          iconColor={'#FFF'}
          iconSize={15}
          buttonColor={'pink'}
          onClick={onAdd}
          id="add_new_contact_btn"
        />
      </div>
    </div>
  )
}

export default ContactHeader
